import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100vh;
  background-color: #fff;
  padding: 40px;
  box-sizing: border-box;
  overflow: hidden;
  @media (max-width: 768px) {
    padding: 20px;
    height: auto;
  }
`;

export const CarouselContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  flex-basis: 70%;
  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    width: 100%;
    flex-wrap: nowrap;
  }
`;

export const TextContainer = styled.div`
  width: 100%;
  flex-basis: 50%;
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 15px;
  }
`;

export const SectionTitle = styled.p`
  font-family: "Poppins", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 1rem;
  color: #c6c661;
  font-weight: 600;
  text-align: center;
  margin-top: 30px;
  color: #252528;

  @media (max-width: 768px) {
    font-size: 1.5rem;
    line-height: 25px;
    margin-top: 0px;
  }
`;
export const SectionSubtitle = styled.div`
  font-family: "Poppins", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 1.5rem;
  color: #000000;
  font-weight: 400;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 1.5;
    line-height: 25px;
  }
`;

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-block: 20px;
  font-family: "Poppins";
  font-weight: 400;
  color: #333333;
  font-size: 0.9rem;
  /* margin-left: 12px; */
  margin-top: 5px;
  text-align: justify;
`;
export const Heading = styled.span`
  font-size: 1rem;
  font-family: "Poppins";
  font-weight: 700;
  color: #252528;
`;

export const Title = styled.p`
  font-size: 1.3rem;
  font-family: "Poppins";
  font-weight: 700;
  color: #252528;
  margin-bottom: 5px;
`;

export const Description = styled.span`
  font-family: "Poppins";
  font-weight: 400;
  color: #333333;
  font-size: 0.9rem;
  /* margin-left: 12px; */
  margin-top: 5px;
  text-align: justify;
`;

export const KeyTitle = styled.span`
  font-family: "Poppins";
  font-weight: 600;
  font-size: 0.9rem;
  margin-top: 5px;
  color: #252528;
`;

export const Italic = styled.span`
  font-family: "Poppins";
  font-weight: 500;
  font-style: italic;
  font-size: 0.9rem;
  color: #252528;
`;

export const KeyPoint = styled.span`
  font-family: "Poppins";
  font-weight: 400;
  font-size: 0.9rem;
  margin-top: 5px;
  color: #333333;
`;

export const Point = styled.span`
  font-family: "Poppins";
  font-weight: 700;
  font-size: 1.2rem;
  margin-top: 5px;
  color: #000;
`;

export const List = styled.ul`
  margin-top: 10px;
`;

export const Item = styled.li`
  margin-top: 10px;
`;

export const Table = styled.table`
  border-collapse: collapse;
`;

export const Tr = styled.tr`
  height: 100px;
  :nth-child(odd) {
    background: orange;
    color: #fff;
  }
`;

export const Td = styled.td`
  padding: 20px;
  width: 20px;
  box-sizing: border-box;
  font-size: 1rem;
`;

export const Bold = styled.span`
  font-family: "Poppins";
  font-weight: 700;
  font-size: 1rem;
`;

export const Fieldset = styled.fieldset`
  border: none;
  border-top: 1px solid #c6c661;
  margin-top: 30px;
`;

export const Legend = styled.legend`
  font-family: "Poppins";
  font-weight: 600;
  font-size: 1.5rem;
  width: 50vw;
  text-align: center;
  @media (max-width: 768px) {
    width: 50vw;
  }
`;
